module.exports = __webpack_public_path__ + "img/iso27001.3356975b.png";